import React, {useState} from "react";
import {NavLink} from "react-router-dom";
import ContentBox from "../../../../../../components/content-box/ContentBox";
import PageActions from "../../../../../base/PageActions";
import Breadcrumbs from "../../../../../../components/breadcrumbs/Breadcrumbs";
import Modal from "../../../../../../components/modal/Modal";
import _image_service from "../../../../../../services/ImageService";
import '../../../../../styles/Common.scss';
import '../../WorldPages.scss';
import '../../WorldDynamicContent.scss';

interface IndustrialHistoryPageProps {
}

const IndustrialHistoryPage = (props: IndustrialHistoryPageProps) => {

    const _map_src = `chase/world/geography/casarok_post_cataclysm.png`;

    const page: PageActions = new PageActions({
        title: `Casarok History: Industrial Age - Chase the Fox`,
        description: "The Industrial Age of Casarok was the time in which factories and corporations boomed in the world of Casarok!",
        keywords: ["casarok", "casarok history", "industrial age", "fantasy timeline", "fantasy world history", "fantasy industrial age"],
        imgSrc: _map_src,
        url: `world/history/industrial-age`
    });

    const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);

    return page.generateMetaContent(
        <>
            <Modal isOpen={modalIsOpen}
                   onClose={() => setModalIsOpen(false)}>
                <div className="geography-modal-view">
                    <p className="center">
                        <a href={_image_service.getCdnImageSrc(_map_src, 'full')}
                           target="_blank"
                           rel="noopener noreferrer">
                            Click here to view the full size image.
                        </a>
                    </p>
                    <img src={_image_service.getCdnImageSrc(_map_src, 'desktop')}
                         title='Casarok Post-Cataclysm Map'
                         alt="A map of Casarok after the Great Cataclysm"/>
                </div>
            </Modal>
            <ContentBox header="The Industrial Age of Casarok">
                <Breadcrumbs path={page.getUrl()}/>
                <div className="world-page-static">
                    <a id="visible-element"
                       className="switch-visible geography-modal-link"
                       onClick={() => setModalIsOpen(true)}>
                        <img className="block width-50-percent"
                             src={_image_service.getCdnImageSrc(`chase/world/geography/casarok_post_cataclysm.png`)}
                             title='Casarok Post-Cataclysm Map'
                             alt="A map of Casarok after the Great Cataclysm"/>
                    </a>
                </div>
                <div className="world-page-static">
                    <p className="center">
                        <em>This age covers the years 1700 - 1800 ACE.</em>
                    </p>
                    <p>
                        The Industrial Age was a time of economic advancement built from oil, coal, and electricity.
                        Following the fall of steam and clockwork during
                        the <NavLink className="world-link" to="/world/history/enlightened-age">previous age</NavLink>, having
                        a new non-magical source of electrical power gave new life to the anthros of the world. Fossil 
                        fuels also led the way to factories which in turn led to means of mass production. Quality of 
                        life in Casarok was vastly improved as necessities became available in large quantities and
                        their cost reduced dramatically.
                    </p>
                    <p>
                        One downside of the rise of factories, however, was the capital control over these means of
                        production. Many places faced wealth inequality and lack of worker's right for a time as modern
                        barons amassed their fortunes. They used their wealth to buy land, power, and influence. The
                        center of this power ended up being the Magnates' Collective based in Garebolis. They organized a
                        group consisting of some the world's wealthiest people to consolidate power. They attempted to 
                        use their influence to seize control of the world economy with the goals of creating a new world 
                        order with them at the helm and to run the world dry of resources to further their own power. It
                        took the work of collectives and governments to reign in their power and bring equity back to
                        the populace.
                    </p>
                    <p>
                        <em>How does Casarok's Industrial Age differ from the same period on Earth?</em><br/>
                        No single entity had control of the world economy on Earth like the Magnates' Collective was
                        attempting to bring together on Casarok. Air travel already was in existence as well, given that
                        zeppelins and airships were introduced in the previous age of Casarok, even prior to the 
                        invention of airplanes. Subterranean cities also served to provide more coal and oil on Casarok
                        than could be harvested on Earth at the same point in time.
                    </p>
                    <h3 className="headline">Notable Events</h3>
                    <ul className="spaced">
                        <li>
                            <em>1701 ACE</em>: The first coal powered engine leads to the inventions of the railroad,
                            coal-powered ocean liners, and coal-engine airships.
                        </li>
                        <li>
                            <em>1704 ACE</em>: The first coal-powered factory opens in Garebolis.
                        </li>
                        <li>
                            <em>1706 ACE</em>: The first oil refinery opens in Tezcatli close to recently discovered 
                            oil reserves.
                        </li>
                        <li>
                            <em>1710 ACE</em>: Improvements in trains and airships make fast land travel much faster for
                            the general populace.
                        </li>
                        <li>
                            <em>1716 ACE</em>: Factories pop up rapidly around the world, but they increase at a much
                            faster rate in Garebolian cities.
                        </li>
                        <li>
                            <em>1719 ACE</em>: The telegraph is invented.
                        </li>
                        <li>
                            <em>1722 ACE</em>: The country of Bovas becomes a province of Haluthe.
                        </li>
                        <li>
                            <em>1727 ACE</em>: The Magnates' Collective is secretly established among many of the world's
                            elite.
                        </li>
                        <li>
                            <em>1734 ACE</em>: The members of the Magnates' Collective establish their own secret
                            telegraph network once their plan is nearly unveiled by a journalist.
                        </li>
                        <li>
                            <em>1738 ACE</em>: The light bulb is invented. The members of the Magnates' Collective begin to consolidate power in
                            their respective countries by buying land and bribing officials.
                        </li>
                        <li>
                            <em>1742 ACE</em>: The members of the Magnates' Collective begin to consolidate power in
                            their respective countries by buying land and bribing officials.
                        </li>
                        <li>
                            <em>1757 ACE</em>: The Magnates' Collective is uncovered leading to outrage among the
                            general populace.
                        </li>
                        <li>
                            <em>1761 ACE</em>: Workers' collectives begin fighting to wrest control back to the people
                            from the Magnates' Collective.
                        </li>
                        <li>
                            <em>1763 ACE</em>: The rogue nation of Elinea breaks away from Moreus, citing corruption
                            among the major powers of the world as a reason for their secession.
                        </li>
                        <li>
                            <em>1765 ACE</em>: The governments of the world are almost helpless to the economic power
                            of the Magnates' Collective.
                        </li>
                        <li>
                            <em>1767 ACE</em>: The headquarters of the Magnates' Collective in Garebolis is invaded.
                            The mastermind behind the operation is eliminated.
                        </li>
                        <li>
                            <em>1776 ACE</em>: The Magnates' Collective is fully dissolved, and many of the monopolies
                            held by its members are broken up.
                        </li>
                        <li>
                            <em>1782 ACE</em>: The first airplane flight without the use of magical energy is made.
                        </li>
                        <li>
                            <em>1789 ACE</em>: The nation of Nikote collapses, forming the new nations of Eistin and
                            Eidsin.
                        </li>
                        <li>
                            <em>1797 ACE</em>: The first triggerable magic enchantment is used by a mage, leading the
                            way to the simple programmable magic used
                            in <NavLink className="world-link" to="/world/magic/items/mage-tech">mage-tech</NavLink>.
                        </li>
                    </ul>
                </div>
            </ContentBox>
        </>
    );
}

export default IndustrialHistoryPage;